import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all, select } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
} from './actions';

export function* requestTurnoAcompanhamento({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'statusturnoacompanhamento', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}



export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'statusturnoacompanhamento', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* refresh() {
  try {

    const { params } = yield select((state) => state.turnoAcompanhamento)

    const response = yield call(api.get, 'statusturnoacompanhamento', {
      params: { ...params, pesquisalista: true },
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@turnoacompanhamento/TURNOACOMPANHAMENTO_IN_REQUEST', requestTurnoAcompanhamento),
  takeLatest('@turnoacompanhamento/SUCCESS_REMOVE', requestTurnoAcompanhamento),
  takeLatest('@turnoacompanhamento/RECORD_FILTERING', applyedFilters),
  takeLatest('@turnoacompanhamento/REFRESH', refresh),
]);
